import { NotificationPatchPayload } from '../src/notifications.model';

export namespace NotificationsActions {
  export class LoadSummary {
    static readonly type = '[Notifications] Load Summary';
  }

  export class SaveInstance {
    static readonly type = '[Notifications] Save Instance';
    constructor(
      public readonly spanvaId: string,
      public readonly payload: NotificationPatchPayload,
    ) {}
  }
}
